export default __webpack_public_path__ + "static/stats-d18516448b895925df86917ea3f646e3.png";